@if (changeTab$ | async) {}

@if (activeRoute$ | async; as active) {
  <div
    class="flex st-top-header-tabs"
    zHorizontalScrollDetection
    (hasHorizontalScroll)="onScrollChange($event)"
    [breakpoint]="active?.children?.length"
  >
    @if (active?.children && active?.children?.length) {
      @if (!singleTab()) {
        @for (tab of active?.children; track $index) {
          <z-top-header-tab
            [tabData]="tab"
            [active]="this.activeChild?.id === tab.id"
          />
        }
      } @else {
        <z-top-header-single-tab [navigationItem]="active" />
      }
    } @else {
      @if (standaloneTitle()) {
        <z-top-header-standalone-title [title]="standaloneTitle()" />
      }
    }
  </div>
} @else if (standaloneTitle()) {
  <div class="flex st-top-header-tabs">
    <z-top-header-standalone-title [title]="standaloneTitle()" />
  </div>
}
